export default __webpack_public_path__ + "static/media/usa-flag.eae218b7.png";